import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  shortcuts: null,
  enabled: true,
};

const shortcuts = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default shortcuts;
